import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, Output, ContentChildren, forwardRef, Inject } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, CollectionNestedOption, extractTemplate, DxTemplateHost } from 'devextreme-angular/core';
import { DOCUMENT } from '@angular/common';

/*!
 * devextreme-angular
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
const _c0 = ["*"];
let DxoHtmlEditorConverterComponent = /*#__PURE__*/(() => {
  class DxoHtmlEditorConverterComponent extends NestedOption {
    get fromHtml() {
      return this._getOption('fromHtml');
    }
    set fromHtml(value) {
      this._setOption('fromHtml', value);
    }
    get toHtml() {
      return this._getOption('toHtml');
    }
    set toHtml(value) {
      this._setOption('toHtml', value);
    }
    get _optionPath() {
      return 'converter';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHtmlEditorConverterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorConverterComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHtmlEditorConverterComponent,
      selectors: [["dxo-html-editor-converter"]],
      inputs: {
        fromHtml: "fromHtml",
        toHtml: "toHtml"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHtmlEditorConverterComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoHtmlEditorConverterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHtmlEditorConverterModule = /*#__PURE__*/(() => {
  class DxoHtmlEditorConverterModule {
    /** @nocollapse */static ɵfac = function DxoHtmlEditorConverterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorConverterModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHtmlEditorConverterModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoHtmlEditorConverterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHtmlEditorFileUploaderOptionsComponent = /*#__PURE__*/(() => {
  class DxoHtmlEditorFileUploaderOptionsComponent extends NestedOption {
    get abortUpload() {
      return this._getOption('abortUpload');
    }
    set abortUpload(value) {
      this._setOption('abortUpload', value);
    }
    get accept() {
      return this._getOption('accept');
    }
    set accept(value) {
      this._setOption('accept', value);
    }
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    get allowCanceling() {
      return this._getOption('allowCanceling');
    }
    set allowCanceling(value) {
      this._setOption('allowCanceling', value);
    }
    get allowedFileExtensions() {
      return this._getOption('allowedFileExtensions');
    }
    set allowedFileExtensions(value) {
      this._setOption('allowedFileExtensions', value);
    }
    get chunkSize() {
      return this._getOption('chunkSize');
    }
    set chunkSize(value) {
      this._setOption('chunkSize', value);
    }
    get dialogTrigger() {
      return this._getOption('dialogTrigger');
    }
    set dialogTrigger(value) {
      this._setOption('dialogTrigger', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get dropZone() {
      return this._getOption('dropZone');
    }
    set dropZone(value) {
      this._setOption('dropZone', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get inputAttr() {
      return this._getOption('inputAttr');
    }
    set inputAttr(value) {
      this._setOption('inputAttr', value);
    }
    get invalidFileExtensionMessage() {
      return this._getOption('invalidFileExtensionMessage');
    }
    set invalidFileExtensionMessage(value) {
      this._setOption('invalidFileExtensionMessage', value);
    }
    get invalidMaxFileSizeMessage() {
      return this._getOption('invalidMaxFileSizeMessage');
    }
    set invalidMaxFileSizeMessage(value) {
      this._setOption('invalidMaxFileSizeMessage', value);
    }
    get invalidMinFileSizeMessage() {
      return this._getOption('invalidMinFileSizeMessage');
    }
    set invalidMinFileSizeMessage(value) {
      this._setOption('invalidMinFileSizeMessage', value);
    }
    get isDirty() {
      return this._getOption('isDirty');
    }
    set isDirty(value) {
      this._setOption('isDirty', value);
    }
    get isValid() {
      return this._getOption('isValid');
    }
    set isValid(value) {
      this._setOption('isValid', value);
    }
    get labelText() {
      return this._getOption('labelText');
    }
    set labelText(value) {
      this._setOption('labelText', value);
    }
    get maxFileSize() {
      return this._getOption('maxFileSize');
    }
    set maxFileSize(value) {
      this._setOption('maxFileSize', value);
    }
    get minFileSize() {
      return this._getOption('minFileSize');
    }
    set minFileSize(value) {
      this._setOption('minFileSize', value);
    }
    get multiple() {
      return this._getOption('multiple');
    }
    set multiple(value) {
      this._setOption('multiple', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get onBeforeSend() {
      return this._getOption('onBeforeSend');
    }
    set onBeforeSend(value) {
      this._setOption('onBeforeSend', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onDropZoneEnter() {
      return this._getOption('onDropZoneEnter');
    }
    set onDropZoneEnter(value) {
      this._setOption('onDropZoneEnter', value);
    }
    get onDropZoneLeave() {
      return this._getOption('onDropZoneLeave');
    }
    set onDropZoneLeave(value) {
      this._setOption('onDropZoneLeave', value);
    }
    get onFilesUploaded() {
      return this._getOption('onFilesUploaded');
    }
    set onFilesUploaded(value) {
      this._setOption('onFilesUploaded', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onProgress() {
      return this._getOption('onProgress');
    }
    set onProgress(value) {
      this._setOption('onProgress', value);
    }
    get onUploadAborted() {
      return this._getOption('onUploadAborted');
    }
    set onUploadAborted(value) {
      this._setOption('onUploadAborted', value);
    }
    get onUploaded() {
      return this._getOption('onUploaded');
    }
    set onUploaded(value) {
      this._setOption('onUploaded', value);
    }
    get onUploadError() {
      return this._getOption('onUploadError');
    }
    set onUploadError(value) {
      this._setOption('onUploadError', value);
    }
    get onUploadStarted() {
      return this._getOption('onUploadStarted');
    }
    set onUploadStarted(value) {
      this._setOption('onUploadStarted', value);
    }
    get onValueChanged() {
      return this._getOption('onValueChanged');
    }
    set onValueChanged(value) {
      this._setOption('onValueChanged', value);
    }
    get progress() {
      return this._getOption('progress');
    }
    set progress(value) {
      this._setOption('progress', value);
    }
    get readOnly() {
      return this._getOption('readOnly');
    }
    set readOnly(value) {
      this._setOption('readOnly', value);
    }
    get readyToUploadMessage() {
      return this._getOption('readyToUploadMessage');
    }
    set readyToUploadMessage(value) {
      this._setOption('readyToUploadMessage', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get selectButtonText() {
      return this._getOption('selectButtonText');
    }
    set selectButtonText(value) {
      this._setOption('selectButtonText', value);
    }
    get showFileList() {
      return this._getOption('showFileList');
    }
    set showFileList(value) {
      this._setOption('showFileList', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get uploadAbortedMessage() {
      return this._getOption('uploadAbortedMessage');
    }
    set uploadAbortedMessage(value) {
      this._setOption('uploadAbortedMessage', value);
    }
    get uploadButtonText() {
      return this._getOption('uploadButtonText');
    }
    set uploadButtonText(value) {
      this._setOption('uploadButtonText', value);
    }
    get uploadChunk() {
      return this._getOption('uploadChunk');
    }
    set uploadChunk(value) {
      this._setOption('uploadChunk', value);
    }
    get uploadCustomData() {
      return this._getOption('uploadCustomData');
    }
    set uploadCustomData(value) {
      this._setOption('uploadCustomData', value);
    }
    get uploadedMessage() {
      return this._getOption('uploadedMessage');
    }
    set uploadedMessage(value) {
      this._setOption('uploadedMessage', value);
    }
    get uploadFailedMessage() {
      return this._getOption('uploadFailedMessage');
    }
    set uploadFailedMessage(value) {
      this._setOption('uploadFailedMessage', value);
    }
    get uploadFile() {
      return this._getOption('uploadFile');
    }
    set uploadFile(value) {
      this._setOption('uploadFile', value);
    }
    get uploadHeaders() {
      return this._getOption('uploadHeaders');
    }
    set uploadHeaders(value) {
      this._setOption('uploadHeaders', value);
    }
    get uploadMethod() {
      return this._getOption('uploadMethod');
    }
    set uploadMethod(value) {
      this._setOption('uploadMethod', value);
    }
    get uploadMode() {
      return this._getOption('uploadMode');
    }
    set uploadMode(value) {
      this._setOption('uploadMode', value);
    }
    get uploadUrl() {
      return this._getOption('uploadUrl');
    }
    set uploadUrl(value) {
      this._setOption('uploadUrl', value);
    }
    get validationError() {
      return this._getOption('validationError');
    }
    set validationError(value) {
      this._setOption('validationError', value);
    }
    get validationErrors() {
      return this._getOption('validationErrors');
    }
    set validationErrors(value) {
      this._setOption('validationErrors', value);
    }
    get validationStatus() {
      return this._getOption('validationStatus');
    }
    set validationStatus(value) {
      this._setOption('validationStatus', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    valueChange;
    get _optionPath() {
      return 'fileUploaderOptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'valueChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHtmlEditorFileUploaderOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorFileUploaderOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHtmlEditorFileUploaderOptionsComponent,
      selectors: [["dxo-html-editor-file-uploader-options"]],
      inputs: {
        abortUpload: "abortUpload",
        accept: "accept",
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        allowCanceling: "allowCanceling",
        allowedFileExtensions: "allowedFileExtensions",
        chunkSize: "chunkSize",
        dialogTrigger: "dialogTrigger",
        disabled: "disabled",
        dropZone: "dropZone",
        elementAttr: "elementAttr",
        focusStateEnabled: "focusStateEnabled",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        inputAttr: "inputAttr",
        invalidFileExtensionMessage: "invalidFileExtensionMessage",
        invalidMaxFileSizeMessage: "invalidMaxFileSizeMessage",
        invalidMinFileSizeMessage: "invalidMinFileSizeMessage",
        isDirty: "isDirty",
        isValid: "isValid",
        labelText: "labelText",
        maxFileSize: "maxFileSize",
        minFileSize: "minFileSize",
        multiple: "multiple",
        name: "name",
        onBeforeSend: "onBeforeSend",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onDropZoneEnter: "onDropZoneEnter",
        onDropZoneLeave: "onDropZoneLeave",
        onFilesUploaded: "onFilesUploaded",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onProgress: "onProgress",
        onUploadAborted: "onUploadAborted",
        onUploaded: "onUploaded",
        onUploadError: "onUploadError",
        onUploadStarted: "onUploadStarted",
        onValueChanged: "onValueChanged",
        progress: "progress",
        readOnly: "readOnly",
        readyToUploadMessage: "readyToUploadMessage",
        rtlEnabled: "rtlEnabled",
        selectButtonText: "selectButtonText",
        showFileList: "showFileList",
        tabIndex: "tabIndex",
        uploadAbortedMessage: "uploadAbortedMessage",
        uploadButtonText: "uploadButtonText",
        uploadChunk: "uploadChunk",
        uploadCustomData: "uploadCustomData",
        uploadedMessage: "uploadedMessage",
        uploadFailedMessage: "uploadFailedMessage",
        uploadFile: "uploadFile",
        uploadHeaders: "uploadHeaders",
        uploadMethod: "uploadMethod",
        uploadMode: "uploadMode",
        uploadUrl: "uploadUrl",
        validationError: "validationError",
        validationErrors: "validationErrors",
        validationStatus: "validationStatus",
        value: "value",
        visible: "visible",
        width: "width"
      },
      outputs: {
        valueChange: "valueChange"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHtmlEditorFileUploaderOptionsComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoHtmlEditorFileUploaderOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHtmlEditorFileUploaderOptionsModule = /*#__PURE__*/(() => {
  class DxoHtmlEditorFileUploaderOptionsModule {
    /** @nocollapse */static ɵfac = function DxoHtmlEditorFileUploaderOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorFileUploaderOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHtmlEditorFileUploaderOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoHtmlEditorFileUploaderOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiHtmlEditorTabComponent = /*#__PURE__*/(() => {
  class DxiHtmlEditorTabComponent extends CollectionNestedOption {
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get _optionPath() {
      return 'tabs';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiHtmlEditorTabComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiHtmlEditorTabComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiHtmlEditorTabComponent,
      selectors: [["dxi-html-editor-tab"]],
      inputs: {
        name: "name"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiHtmlEditorTabComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiHtmlEditorTabComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiHtmlEditorTabModule = /*#__PURE__*/(() => {
  class DxiHtmlEditorTabModule {
    /** @nocollapse */static ɵfac = function DxiHtmlEditorTabModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiHtmlEditorTabModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiHtmlEditorTabModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxiHtmlEditorTabModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHtmlEditorImageUploadComponent = /*#__PURE__*/(() => {
  class DxoHtmlEditorImageUploadComponent extends NestedOption {
    get fileUploaderOptions() {
      return this._getOption('fileUploaderOptions');
    }
    set fileUploaderOptions(value) {
      this._setOption('fileUploaderOptions', value);
    }
    get fileUploadMode() {
      return this._getOption('fileUploadMode');
    }
    set fileUploadMode(value) {
      this._setOption('fileUploadMode', value);
    }
    get tabs() {
      return this._getOption('tabs');
    }
    set tabs(value) {
      this._setOption('tabs', value);
    }
    get uploadDirectory() {
      return this._getOption('uploadDirectory');
    }
    set uploadDirectory(value) {
      this._setOption('uploadDirectory', value);
    }
    get uploadUrl() {
      return this._getOption('uploadUrl');
    }
    set uploadUrl(value) {
      this._setOption('uploadUrl', value);
    }
    get _optionPath() {
      return 'imageUpload';
    }
    get tabsChildren() {
      return this._getOption('tabs');
    }
    set tabsChildren(value) {
      this.setChildren('tabs', value);
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHtmlEditorImageUploadComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorImageUploadComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHtmlEditorImageUploadComponent,
      selectors: [["dxo-html-editor-image-upload"]],
      contentQueries: function DxoHtmlEditorImageUploadComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, DxiHtmlEditorTabComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabsChildren = _t);
        }
      },
      inputs: {
        fileUploaderOptions: "fileUploaderOptions",
        fileUploadMode: "fileUploadMode",
        tabs: "tabs",
        uploadDirectory: "uploadDirectory",
        uploadUrl: "uploadUrl"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHtmlEditorImageUploadComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoHtmlEditorImageUploadComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHtmlEditorImageUploadModule = /*#__PURE__*/(() => {
  class DxoHtmlEditorImageUploadModule {
    /** @nocollapse */static ɵfac = function DxoHtmlEditorImageUploadModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorImageUploadModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHtmlEditorImageUploadModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoHtmlEditorImageUploadModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiHtmlEditorItemComponent = /*#__PURE__*/(() => {
  class DxiHtmlEditorItemComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get beginGroup() {
      return this._getOption('beginGroup');
    }
    set beginGroup(value) {
      this._setOption('beginGroup', value);
    }
    get closeMenuOnClick() {
      return this._getOption('closeMenuOnClick');
    }
    set closeMenuOnClick(value) {
      this._setOption('closeMenuOnClick', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get selectable() {
      return this._getOption('selectable');
    }
    set selectable(value) {
      this._setOption('selectable', value);
    }
    get selected() {
      return this._getOption('selected');
    }
    set selected(value) {
      this._setOption('selected', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get acceptedValues() {
      return this._getOption('acceptedValues');
    }
    set acceptedValues(value) {
      this._setOption('acceptedValues', value);
    }
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get formatName() {
      return this._getOption('formatName');
    }
    set formatName(value) {
      this._setOption('formatName', value);
    }
    get formatValues() {
      return this._getOption('formatValues');
    }
    set formatValues(value) {
      this._setOption('formatValues', value);
    }
    get html() {
      return this._getOption('html');
    }
    set html(value) {
      this._setOption('html', value);
    }
    get locateInMenu() {
      return this._getOption('locateInMenu');
    }
    set locateInMenu(value) {
      this._setOption('locateInMenu', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get menuItemTemplate() {
      return this._getOption('menuItemTemplate');
    }
    set menuItemTemplate(value) {
      this._setOption('menuItemTemplate', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get showText() {
      return this._getOption('showText');
    }
    set showText(value) {
      this._setOption('showText', value);
    }
    get widget() {
      return this._getOption('widget');
    }
    set widget(value) {
      this._setOption('widget', value);
    }
    get _optionPath() {
      return 'items';
    }
    get itemsChildren() {
      return this._getOption('items');
    }
    set itemsChildren(value) {
      this.setChildren('items', value);
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiHtmlEditorItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiHtmlEditorItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiHtmlEditorItemComponent,
      selectors: [["dxi-html-editor-item"]],
      contentQueries: function DxiHtmlEditorItemComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, DxiHtmlEditorItemComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemsChildren = _t);
        }
      },
      inputs: {
        beginGroup: "beginGroup",
        closeMenuOnClick: "closeMenuOnClick",
        disabled: "disabled",
        icon: "icon",
        items: "items",
        name: "name",
        selectable: "selectable",
        selected: "selected",
        template: "template",
        text: "text",
        visible: "visible",
        acceptedValues: "acceptedValues",
        cssClass: "cssClass",
        formatName: "formatName",
        formatValues: "formatValues",
        html: "html",
        locateInMenu: "locateInMenu",
        location: "location",
        menuItemTemplate: "menuItemTemplate",
        options: "options",
        showText: "showText",
        widget: "widget"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiHtmlEditorItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiHtmlEditorItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiHtmlEditorItemModule = /*#__PURE__*/(() => {
  class DxiHtmlEditorItemModule {
    /** @nocollapse */static ɵfac = function DxiHtmlEditorItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiHtmlEditorItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiHtmlEditorItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxiHtmlEditorItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHtmlEditorMediaResizingComponent = /*#__PURE__*/(() => {
  class DxoHtmlEditorMediaResizingComponent extends NestedOption {
    get allowedTargets() {
      return this._getOption('allowedTargets');
    }
    set allowedTargets(value) {
      this._setOption('allowedTargets', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get _optionPath() {
      return 'mediaResizing';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHtmlEditorMediaResizingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorMediaResizingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHtmlEditorMediaResizingComponent,
      selectors: [["dxo-html-editor-media-resizing"]],
      inputs: {
        allowedTargets: "allowedTargets",
        enabled: "enabled"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHtmlEditorMediaResizingComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoHtmlEditorMediaResizingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHtmlEditorMediaResizingModule = /*#__PURE__*/(() => {
  class DxoHtmlEditorMediaResizingModule {
    /** @nocollapse */static ɵfac = function DxoHtmlEditorMediaResizingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorMediaResizingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHtmlEditorMediaResizingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoHtmlEditorMediaResizingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiHtmlEditorMentionComponent = /*#__PURE__*/(() => {
  class DxiHtmlEditorMentionComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get displayExpr() {
      return this._getOption('displayExpr');
    }
    set displayExpr(value) {
      this._setOption('displayExpr', value);
    }
    get itemTemplate() {
      return this._getOption('itemTemplate');
    }
    set itemTemplate(value) {
      this._setOption('itemTemplate', value);
    }
    get marker() {
      return this._getOption('marker');
    }
    set marker(value) {
      this._setOption('marker', value);
    }
    get minSearchLength() {
      return this._getOption('minSearchLength');
    }
    set minSearchLength(value) {
      this._setOption('minSearchLength', value);
    }
    get searchExpr() {
      return this._getOption('searchExpr');
    }
    set searchExpr(value) {
      this._setOption('searchExpr', value);
    }
    get searchTimeout() {
      return this._getOption('searchTimeout');
    }
    set searchTimeout(value) {
      this._setOption('searchTimeout', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get valueExpr() {
      return this._getOption('valueExpr');
    }
    set valueExpr(value) {
      this._setOption('valueExpr', value);
    }
    get _optionPath() {
      return 'mentions';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiHtmlEditorMentionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiHtmlEditorMentionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiHtmlEditorMentionComponent,
      selectors: [["dxi-html-editor-mention"]],
      inputs: {
        dataSource: "dataSource",
        displayExpr: "displayExpr",
        itemTemplate: "itemTemplate",
        marker: "marker",
        minSearchLength: "minSearchLength",
        searchExpr: "searchExpr",
        searchTimeout: "searchTimeout",
        template: "template",
        valueExpr: "valueExpr"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiHtmlEditorMentionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiHtmlEditorMentionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiHtmlEditorMentionModule = /*#__PURE__*/(() => {
  class DxiHtmlEditorMentionModule {
    /** @nocollapse */static ɵfac = function DxiHtmlEditorMentionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiHtmlEditorMentionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiHtmlEditorMentionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxiHtmlEditorMentionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiHtmlEditorTableContextMenuItemComponent = /*#__PURE__*/(() => {
  class DxiHtmlEditorTableContextMenuItemComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get beginGroup() {
      return this._getOption('beginGroup');
    }
    set beginGroup(value) {
      this._setOption('beginGroup', value);
    }
    get closeMenuOnClick() {
      return this._getOption('closeMenuOnClick');
    }
    set closeMenuOnClick(value) {
      this._setOption('closeMenuOnClick', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get selectable() {
      return this._getOption('selectable');
    }
    set selectable(value) {
      this._setOption('selectable', value);
    }
    get selected() {
      return this._getOption('selected');
    }
    set selected(value) {
      this._setOption('selected', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'items';
    }
    get itemsChildren() {
      return this._getOption('items');
    }
    set itemsChildren(value) {
      this.setChildren('items', value);
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiHtmlEditorTableContextMenuItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiHtmlEditorTableContextMenuItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiHtmlEditorTableContextMenuItemComponent,
      selectors: [["dxi-html-editor-table-context-menu-item"]],
      contentQueries: function DxiHtmlEditorTableContextMenuItemComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, DxiHtmlEditorItemComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemsChildren = _t);
        }
      },
      inputs: {
        beginGroup: "beginGroup",
        closeMenuOnClick: "closeMenuOnClick",
        disabled: "disabled",
        icon: "icon",
        items: "items",
        name: "name",
        selectable: "selectable",
        selected: "selected",
        template: "template",
        text: "text",
        visible: "visible"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiHtmlEditorTableContextMenuItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiHtmlEditorTableContextMenuItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiHtmlEditorTableContextMenuItemModule = /*#__PURE__*/(() => {
  class DxiHtmlEditorTableContextMenuItemModule {
    /** @nocollapse */static ɵfac = function DxiHtmlEditorTableContextMenuItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiHtmlEditorTableContextMenuItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiHtmlEditorTableContextMenuItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxiHtmlEditorTableContextMenuItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHtmlEditorTableContextMenuComponent = /*#__PURE__*/(() => {
  class DxoHtmlEditorTableContextMenuComponent extends NestedOption {
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get _optionPath() {
      return 'tableContextMenu';
    }
    get itemsChildren() {
      return this._getOption('items');
    }
    set itemsChildren(value) {
      this.setChildren('items', value);
    }
    get tableContextMenuItemsChildren() {
      return this._getOption('items');
    }
    set tableContextMenuItemsChildren(value) {
      this.setChildren('items', value);
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHtmlEditorTableContextMenuComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorTableContextMenuComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHtmlEditorTableContextMenuComponent,
      selectors: [["dxo-html-editor-table-context-menu"]],
      contentQueries: function DxoHtmlEditorTableContextMenuComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, DxiHtmlEditorItemComponent, 4);
          i0.ɵɵcontentQuery(dirIndex, DxiHtmlEditorTableContextMenuItemComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemsChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tableContextMenuItemsChildren = _t);
        }
      },
      inputs: {
        enabled: "enabled",
        items: "items"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHtmlEditorTableContextMenuComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoHtmlEditorTableContextMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHtmlEditorTableContextMenuModule = /*#__PURE__*/(() => {
  class DxoHtmlEditorTableContextMenuModule {
    /** @nocollapse */static ɵfac = function DxoHtmlEditorTableContextMenuModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorTableContextMenuModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHtmlEditorTableContextMenuModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoHtmlEditorTableContextMenuModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHtmlEditorTableResizingComponent = /*#__PURE__*/(() => {
  class DxoHtmlEditorTableResizingComponent extends NestedOption {
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get minColumnWidth() {
      return this._getOption('minColumnWidth');
    }
    set minColumnWidth(value) {
      this._setOption('minColumnWidth', value);
    }
    get minRowHeight() {
      return this._getOption('minRowHeight');
    }
    set minRowHeight(value) {
      this._setOption('minRowHeight', value);
    }
    get _optionPath() {
      return 'tableResizing';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHtmlEditorTableResizingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorTableResizingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHtmlEditorTableResizingComponent,
      selectors: [["dxo-html-editor-table-resizing"]],
      inputs: {
        enabled: "enabled",
        minColumnWidth: "minColumnWidth",
        minRowHeight: "minRowHeight"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHtmlEditorTableResizingComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoHtmlEditorTableResizingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHtmlEditorTableResizingModule = /*#__PURE__*/(() => {
  class DxoHtmlEditorTableResizingModule {
    /** @nocollapse */static ɵfac = function DxoHtmlEditorTableResizingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorTableResizingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHtmlEditorTableResizingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoHtmlEditorTableResizingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiHtmlEditorToolbarItemComponent = /*#__PURE__*/(() => {
  class DxiHtmlEditorToolbarItemComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get acceptedValues() {
      return this._getOption('acceptedValues');
    }
    set acceptedValues(value) {
      this._setOption('acceptedValues', value);
    }
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get formatName() {
      return this._getOption('formatName');
    }
    set formatName(value) {
      this._setOption('formatName', value);
    }
    get formatValues() {
      return this._getOption('formatValues');
    }
    set formatValues(value) {
      this._setOption('formatValues', value);
    }
    get html() {
      return this._getOption('html');
    }
    set html(value) {
      this._setOption('html', value);
    }
    get locateInMenu() {
      return this._getOption('locateInMenu');
    }
    set locateInMenu(value) {
      this._setOption('locateInMenu', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get menuItemTemplate() {
      return this._getOption('menuItemTemplate');
    }
    set menuItemTemplate(value) {
      this._setOption('menuItemTemplate', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get showText() {
      return this._getOption('showText');
    }
    set showText(value) {
      this._setOption('showText', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get widget() {
      return this._getOption('widget');
    }
    set widget(value) {
      this._setOption('widget', value);
    }
    get _optionPath() {
      return 'items';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiHtmlEditorToolbarItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiHtmlEditorToolbarItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiHtmlEditorToolbarItemComponent,
      selectors: [["dxi-html-editor-toolbar-item"]],
      inputs: {
        acceptedValues: "acceptedValues",
        cssClass: "cssClass",
        disabled: "disabled",
        formatName: "formatName",
        formatValues: "formatValues",
        html: "html",
        locateInMenu: "locateInMenu",
        location: "location",
        menuItemTemplate: "menuItemTemplate",
        name: "name",
        options: "options",
        showText: "showText",
        template: "template",
        text: "text",
        visible: "visible",
        widget: "widget"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiHtmlEditorToolbarItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiHtmlEditorToolbarItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiHtmlEditorToolbarItemModule = /*#__PURE__*/(() => {
  class DxiHtmlEditorToolbarItemModule {
    /** @nocollapse */static ɵfac = function DxiHtmlEditorToolbarItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiHtmlEditorToolbarItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiHtmlEditorToolbarItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxiHtmlEditorToolbarItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHtmlEditorToolbarComponent = /*#__PURE__*/(() => {
  class DxoHtmlEditorToolbarComponent extends NestedOption {
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get multiline() {
      return this._getOption('multiline');
    }
    set multiline(value) {
      this._setOption('multiline', value);
    }
    get _optionPath() {
      return 'toolbar';
    }
    get itemsChildren() {
      return this._getOption('items');
    }
    set itemsChildren(value) {
      this.setChildren('items', value);
    }
    get toolbarItemsChildren() {
      return this._getOption('items');
    }
    set toolbarItemsChildren(value) {
      this.setChildren('items', value);
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHtmlEditorToolbarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorToolbarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHtmlEditorToolbarComponent,
      selectors: [["dxo-html-editor-toolbar"]],
      contentQueries: function DxoHtmlEditorToolbarComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, DxiHtmlEditorItemComponent, 4);
          i0.ɵɵcontentQuery(dirIndex, DxiHtmlEditorToolbarItemComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemsChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toolbarItemsChildren = _t);
        }
      },
      inputs: {
        container: "container",
        items: "items",
        multiline: "multiline"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHtmlEditorToolbarComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoHtmlEditorToolbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHtmlEditorToolbarModule = /*#__PURE__*/(() => {
  class DxoHtmlEditorToolbarModule {
    /** @nocollapse */static ɵfac = function DxoHtmlEditorToolbarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorToolbarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHtmlEditorToolbarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoHtmlEditorToolbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHtmlEditorVariablesComponent = /*#__PURE__*/(() => {
  class DxoHtmlEditorVariablesComponent extends NestedOption {
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get escapeChar() {
      return this._getOption('escapeChar');
    }
    set escapeChar(value) {
      this._setOption('escapeChar', value);
    }
    get _optionPath() {
      return 'variables';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHtmlEditorVariablesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorVariablesComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHtmlEditorVariablesComponent,
      selectors: [["dxo-html-editor-variables"]],
      inputs: {
        dataSource: "dataSource",
        escapeChar: "escapeChar"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHtmlEditorVariablesComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoHtmlEditorVariablesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHtmlEditorVariablesModule = /*#__PURE__*/(() => {
  class DxoHtmlEditorVariablesModule {
    /** @nocollapse */static ɵfac = function DxoHtmlEditorVariablesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHtmlEditorVariablesModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHtmlEditorVariablesModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoHtmlEditorVariablesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiHtmlEditorItemComponent, DxiHtmlEditorItemModule, DxiHtmlEditorMentionComponent, DxiHtmlEditorMentionModule, DxiHtmlEditorTabComponent, DxiHtmlEditorTabModule, DxiHtmlEditorTableContextMenuItemComponent, DxiHtmlEditorTableContextMenuItemModule, DxiHtmlEditorToolbarItemComponent, DxiHtmlEditorToolbarItemModule, DxoHtmlEditorConverterComponent, DxoHtmlEditorConverterModule, DxoHtmlEditorFileUploaderOptionsComponent, DxoHtmlEditorFileUploaderOptionsModule, DxoHtmlEditorImageUploadComponent, DxoHtmlEditorImageUploadModule, DxoHtmlEditorMediaResizingComponent, DxoHtmlEditorMediaResizingModule, DxoHtmlEditorTableContextMenuComponent, DxoHtmlEditorTableContextMenuModule, DxoHtmlEditorTableResizingComponent, DxoHtmlEditorTableResizingModule, DxoHtmlEditorToolbarComponent, DxoHtmlEditorToolbarModule, DxoHtmlEditorVariablesComponent, DxoHtmlEditorVariablesModule };
